import { Component, OnInit } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexPlotOptions, ApexXAxis
} from "ng-apexcharts";
export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  colors: string[]
};
@Component({
  selector: 'app-client-report',
  templateUrl: './client-report.component.html',
  styleUrls: ['./client-report.component.css']
})
export class ClientReportComponent implements OnInit {
  public chartOptions: Partial<ChartOptions> = {
    series: [
      {
        name: "basic",
        data: [400, 430, 448, 470, 540]
      }
    ],
    chart: {
      type: "bar",
      height: 300
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        columnWidth: '30%',
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: ['LeadWay CRM', 'UBA Payroll', 'X3leasing Payroll', 'ATB CRM', 'Loan35'],
    },
    colors: [
      "rgb(255,177,193))", "rgb(154,208,245)", "rgb(255,230,170)",
      "rgb(165,223,223)", "rgb(204,178,255)"
    ]
  };
  constructor() { }

  ngOnInit() {
  }

}
